import input from './editors/input.js';
import textarea from './editors/textarea.js';
import number from './editors/number.js';
import range from './editors/range.js';
import date from './editors/date.js';
import time from './editors/time.js';
import datetime from './editors/datetime.js';
import list from './editors/list.js';
import star from './editors/star.js';
import progress from './editors/progress.js';
import tickCross from './editors/tickCross.js';

export default {
	input:input,
	textarea:textarea,
	number:number,
	range:range,
	date:date,
	time:time,
	datetime:datetime,
	list:list,
	star:star,
	progress:progress,
	tickCross:tickCross,
};